import { mobxInjectSelect } from 'common/utils';
import { DotsIndicator } from 'common/components';
import StatusBar from 'common/components/StatusBar';
import BEM from 'common/bem';

const classes = BEM.with('OptInBanner');
type OptInBannerProps = {};
type MobxProps = {
  optinRoleNames: string[];
  isOptingIntoRole: boolean;
  hideOptinBanner: () => void;
};
function OptInBanner({
  optinRoleNames,
  isOptingIntoRole,
  hideOptinBanner,
}: OptInBannerProps & MobxProps) {
  const commaSeparatedRoleNames = optinRoleNames.join(', ');
  if (!isOptingIntoRole) {
    return null;
  }
  return (
    <StatusBar
      variant="neutral"
      className={classes('')}
      data-test-id="opt-in-banner"
      onDismiss={hideOptinBanner}
    >
      <DotsIndicator size={12} color={'#8798A4'} />
      <span title={commaSeparatedRoleNames} className={classes('opt-in-text')}>
        Opting into {commaSeparatedRoleNames}
      </span>
    </StatusBar>
  );
}

export default mobxInjectSelect<OptInBannerProps, MobxProps>({
  roleStore: ['optinRoleNames', 'isOptingIntoRole', 'hideOptinBanner'],
})(OptInBanner);
